import { useMemo } from 'react';
import { useExternalConnectionCalendarsQuery } from 'shared/hooks/queries/use-external-connection-calendars-query';
import { ID } from 'shared/types/id';

export const useExternalConnectionCalendars = (connectionId: ID) => {
  const { data } = useExternalConnectionCalendarsQuery(connectionId);

  return useMemo(() => data ?? [], [data]);
};
